module.exports = __webpack_public_path__ + "img/rotate.e663ffb3.gif";